import React from 'react';
import HeroSection from '../components/HeroSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import HowItWorksSection from '../components/HowItWorksSection';
import PricingSection from '../components/PricingSection';
import FAQSection from '../components/FAQSection';

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <WhyChooseUsSection />
      <HowItWorksSection />
      <PricingSection />
      <FAQSection />
    </div>
  );
};

export default HomePage; 